export const TILE_TYPE = {
  EMPTY: 0,
  PHUTBALL: -1,
  PHUTBALL_MAN: 1,
  END_HI: 2,
  END_LO: -2,
};

export const transformCoord = (row, col, perspective, numRows, numCols) => {
  if (perspective === 'south' || perspective === 2) {
    const maxRow = Math.max(0, numRows - 1);
    const maxCol = Math.max(0, numCols - 1);
    return [maxRow - row, maxCol - col];
  }
  return [row, col];
};

/**
 * Render a board grid as labeled text lines using absolute matrix coordinates.
 * Rows are labeled on the left with exactly 2 characters (right-aligned, no zero-pad).
 * Columns are labeled on top using 2 reserved rows: tens digit row, then ones digit row.
 * A single space separator sits between the row label and the grid content.
 *
 * Output for a 15-col board, columns 0-14:
 *                  11111
 *      012345678901234
 *   0 +++++++++++++++
 *   1 +++++++++++++++
 *   ...
 *
 * @param {string[]} gridLines - Array of strings, one per row, each `numCols` chars wide.
 * @param {number} numCols
 * @returns {string[]} Combined header + row lines ready to join with '\n'.
 */
export const renderLabeledBoardLines = (gridLines, numCols) => {
  // Left margin width: 2 chars for row index + 1 space separator
  const leftPad = '   ';
  const tensRow = leftPad + Array.from({ length: numCols }, (_, c) => {
    const tens = Math.floor(c / 10);
    return tens > 0 ? String(tens) : ' ';
  }).join('');
  const onesRow = leftPad + Array.from({ length: numCols }, (_, c) => String(c % 10)).join('');

  const labeledGrid = gridLines.map((row, r) => {
    const label = String(r).padStart(2, ' ');
    return `${label} ${row}`;
  });

  return [tensRow, onesRow, ...labeledGrid];
};

